import React from 'react';
import MaskedInput from 'react-text-mask';
import PropTypes from 'prop-types';
import { claimInputMask, policyNumberInputMask, propertyYearMask, timeMask, plateNumberMask } from '../../../helpers/inputMaskPatterns';

const TextMaskCustom = ({ inputRef, value, ...rest }) => {
  // This component cant receive any other function, and in development mode react returns warning,
  // MUI component cant resolve other props, these are described in typescript core code.
  const handler = {
    timeMask,
    claimInputMask,
    policyNumberInputMask,
    propertyYearMask,
    plateNumberMask,
  };

  return (
    <MaskedInput
      {...rest}
      value={value}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={handler[rest.handler]}
      textmask={{ modelClean: true }}
      guide={false}
      placeholderChar={'\u2000'}
    />
  );
};

TextMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

export default TextMaskCustom;
